import React from 'react'
import BinMaststerTable from '../../Comman/BinMaststerTable'

const BinMaster = () => {

  return (
    <>
        <BinMaststerTable />
    </>
  )
}

export default BinMaster